export const productList = [
  {
    description: "Helps to boost energy and speed up metabolism",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Vitamin B12"],
    },
    name: "Vitamin B12",
    recommended: false,
    url: "https://obm1.co/b12",
  },
  {
    description:
      "All the B vitamins necessary for metabolism and energy-boosting.",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Vitamin B-Complex"],
    },
    name: "Vitamin B-Complex",
    recommended: false,
    url: "https://obm1.co/vbc",
  },
  {
    description:
      "Essential vitamin for immunity and healthy teeth, bones and muscles",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Vitamin D (25-Hydroxy)"],
    },
    name: "Vitamin D",
    recommended: false,
    url: "https://obm1.co/vd",
  },
  {
    description: "An excellent supplement for healthier hair and nails",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Biotin"],
    },
    name: "Biotin",
    recommended: false,
    url: "https://obm1.co/vb",
  },
  {
    description:
      "Increases energy levels, detoxifies the liver, anti-aging and improves the skin",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Glutathione"],
    },
    name: "Glutathione",
    recommended: false,
    url: "https://obm1.co/vg",
  },
  {
    description:
      "Vitamins, minerals, and amino acids to speed up metabolism and burn fat",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Fat Burner"],
    },
    name: "Fat Burner",
    recommended: false,
    url: "https://obm1.co/vfb",
  },
  {
    description: "Detox and boost skin health",
    icon: "click_here.svg",
    linked_tests: {
      low: ["Vitamin C"],
    },
    name: "Vitamin C",
    recommended: false,
    url: "https://obm1.co/vc",
  },
];

export const parameterList = [
  "Total Cholesterol",
  "HDL Cholesterol",
  "LDL Cholesterol",
  "HDL % of total",
  "Direct LDL Cholestrol",
  "HDL : LDL ratio",
  "LDL : HDL ratio",
  "APO B : APO A Ratio",
  "APO A : APO B Ratio",
  "HsCRP",
  "Lipoprotein (a) [Lp(a)]",
  "Apo A",
  "Triglycerides",
  "VLDL",
  "Apo B",
  "Creatine-Kinase",
  "Non - HDL Cholesterol",
  "Total Cholesterol : HDL ratio",
  "HDL :Total Cholesterol ratio",
  "Total Bilirubin",
  "Direct Bilirubin",
  "Indirect Bilirubin",
  "SGOT (AST)",
  "SGOT (ALT)",
  "SGPT (ALT)",
  "SGPT (AST)",
  "AST / ALT Ratio",
  "GGT",
  "ALP",
  "LDH",
  "Protein (Total)",
  "Albumin",
  "Globulin",
  "Albumin : Globulin ratio",
  "Albumin / Creatinine ratio",
  "Serum Creatinine",
  "Uric Acid",
  "Blood Urea",
  "Blood Urea Nitrogen (BUN)",
  "Urea : Creatinine ratio",
  "BUN : Creatinine ratio",
  "Microalbumin : Creatinine ratio",
  "TSH",
  "TSH 3RD GENERATION",
  "Ultra TSH",
  "T3 (Triiodothyronine)",
  "T4 (Thyroxine)",
  "Free T3 (Triiodothyronine)",
  "Free T4 (Thyroxine)",
  "Parathyroid Hormone (PTH)",
  "Anti Thyroglobulin Abs",
  "THYROGLOBULIN",
  "Blood Sugar (Fasting)",
  "Amylase",
  "Blood Sugar (Postprandial)",
  "Blood Sugar (Random)",
  "Insulin (Fasting)",
  "Insulin (Postprandial)",
  "Insulin (Random)",
  "CRP",
  "RA factor (quantitative)",
  "RA factor (descriptive)",
  "ASO (quantitative)",
  "Haemoglobin",
  "Iron",
  "TIBC",
  "UIBC",
  "G6PD (Quantitative)",
  "Ferritin",
  "Transferrin Serum",
  "% Saturation Transferrin",
  "RBC count",
  "Haematocrit",
  "MCV",
  "MENTZER INDEX",
  "MCH",
  "MCHC",
  "Rapid Plasma Reagin",
  "Sickle Cell Solubility Test-Sickling phenomenon",
  "Content Haemoglobin (CH)",
  "Total Leukocyte Count",
  "Platelet Count",
  "Mean Platelet Component (MPC)",
  "Mean Platelet Mass (MPM)",
  "MPV",
  "PDW",
  "PDW - SD",
  "Large Unstained Cell",
  "Absolute Large Unstained Cell",
  "Peripheral smear",
  "PCT",
  "Specific Gravity",
  "pH",
  "Urinary Calcium",
  "Urinary Albumin",
  "Sodium",
  "Body Mass Index(BMI)",
  "Pulse",
  "Height",
  "Weight",
  "Systolic",
  "Diastolic",
  "Blood Pressure",
  "SERUM BICARBONATE(D)",
  "Bicarbonate",
  "Potassium",
  "Chloride",
  "Calcium",
  "Ionized Calcium",
  "Non Ionized Calcium",
  "Corrected Calcium",
  "Zinc",
  "Phosphorus",
  "Magnesium",
  "HbA1c (Glycosylated Haemoglobin)",
  "HbA1c (mmol/mol)",
  "eAG (Estimated Average Glucose)",
  "Neutrophils",
  "Abs. Neutrophil Count",
  "Segmented Neutrophils",
  "Neutrophil Lymphocyte Ratio",
  "Eosinophils",
  "Abs. Eosinophil Count",
  "Basophils",
  "Abs. Basophil Count",
  "Abs. Lymphocyte Count",
  "Abs. Monocyte Count",
  "Lymphocytes",
  "Polymorphs",
  "RBC Morphology",
  "WBC Morphology",
  "Platelate Morphology",
  "Reticulocytes Count",
  "CORRECTED RETICULOCYTE COUNT",
  "ABSOLUTE RETICULOCYTE COUNT",
  "RETICULOCYTE HEAMOGLOBIN EQUIVELENT",
  "IMMATURE PLATELET FRACTION",
  "Monocytes",
  "C-Peptide (Fasting)",
  "C-Peptide (Post prandial)",
  "Myelocytes",
  "Meta-Myelocytes",
  "Pro-Myelocytes",
  "Atypical Lymphocytes (LUC)",
  "Band Cells",
  "Blast Cells",
  "HDW (Haemoglobin Distribution Width)",
  "RDW",
  "RDW-CV",
  "RDW-SD",
  "ESR",
  "Microalbumin",
  "Glucose in Urine",
  "URINE SPOT PROTEIN",
  "URINE SPOT CREATININE",
  "Urine Spot Microalbumin",
  "SPOT PROTEIN & CREATININE RATIO",
  "DEPOSITS :",
  "Urine Colour",
  "Appearance",
  "VOLUME",
  "Pus Cells",
  "Epithelial Cells",
  "Urobilinogen",
  "Protein",
  "Ketone",
  "Acetone",
  "Phosphates/Urates",
  "Bile Salts",
  "Blood",
  "Nitrite",
  "Casts",
  "Pathological Casts",
  "Mucus",
  "Crystals",
  "Bacilli",
  "Bacteria",
  "Yeast cells",
  "Amorphous Deposit",
  "Bile Pigment",
  "Bilirubin",
  "Absorbic Acid",
  "RBC",
  "Leukocytes",
  "Leukocyte Esterase",
  "Sugar in Urine",
  "Other compounds in Urine",
  "Candida in Urine",
  "Vitamin D (25-Hydroxy)",
  "Serum Folate",
  "Vitamin B9",
  "Vitamin B12",
  "Vitamin B1",
  "Vitamin B-Complex",
  "Biotin",
  "Glutathione",
  "Fat Burner",
  "Vitamin B6",
  "Vitamin B2",
  "Vitamin A",
  "Vitamin E",
  "Vitamin C",
  "RBC(PBS)",
  "WBC(PBS)",
  "Platelet(PBS)",
  "Glomerular Filtration Rate",
  "Glomerular Filtration Rate CKD",
  "Albuminuria",
  "P-LCR",
  "P-LCC",
  "Immature Granulocytes",
  "Abs. Immature Granulocytes",
  "Nucleated red blood cells",
  "Absolute Nucleated red blood cells",
  "Urinary Creatinine",
  "Blood Group",
  "Rh Factor",
  "Rh Factor Quantitative",
  "Prostate-Specific Antigen Free",
  "Prostate-Specific Antigen Total",
  "PT TEST",
  "Thrombin Time",
  "PT (Control)",
  "Mean Normal Prothrombic Time",
  "Partial Thromboplastin Time",
  "Activated Partial Thromboplastin Time",
  "Partial Thromboplastin Time(Control)",
  "PT-INR",
  "PT ratio",
  "ISI",
  "Index",
  "Dengue IgG",
  "Dengue IgM",
  "Dengue NS1",
  "HIV",
  "Typhoid (Widal Test)",
  "S.Typhi O Antibody",
  "S.Typhi H Antibody",
  "S.Typhi AH",
  "S.Typhi BH",
  "Malaria (VIVAX)",
  "Malaria (FALCIPARUM)",
  "Malaria Parasite",
  "Prolactin",
  "Urine for Beta HCG",
  "Serum for Beta HCG",
  "Beta HCG",
  "Pregnancy Test Serum",
  "Leutinizing Harmone",
  "AMH2",
  "Estradiol (E2)",
  "FSH",
  "Progesterone",
  "AMH",
  "Estrogen",
  "Oestradiol",
  "SHBG",
  "17-HydroxyProgesterone",
  "Homocysteine",
  "DHEA-Sulphate",
  "Cortosol Random",
  "Testosterone",
  "Testosterone(Free)",
  "Androstenedione",
  "HBsAb",
  "HBsAg",
  "Hepatitis B",
  "HBcAb Total",
  "HBcAb IgM",
  "HCV",
  "HCV AB",
  "Anti HCV",
  "HPV",
  "RAPID TP(SYPHILIS), VDRL",
  "HAV AB IgM",
  "HAV AB",
  "HAV AB Total",
  "CMV AB IgG",
  "CMV AB IgM",
  "CA 19-9",
  "CA 125",
  "CA 15-3",
  "CEA",
  "HIV AB",
  "HIV Combo (Ag+Ab)",
  "VDRL",
  "Herpes Semplex Virus I IgM",
  "Herpes Semplex Virus II IgM",
  "Herpes Semplex Virus",
  "Chlamydia IgM",
  "TPHA (TREPONEMA PALLIDUM)",
  "High Vaginal Swab",
  "Urea Breath Test",
  "Typhidot",
  "WIDAL TEST (SLIDE METHOD)",
  "Gram Stain",
  "Helicobacter Antigen in Stool",
  "Helicobacter Pylori Abs.(IgM)",
  "Helicobacter Pylori Abs.(IgG)",
  "Egg White Allergy",
  "Egg Yolk Allergy",
  "Cow Milk Allergy",
  "Chocolate Allergy",
  "Wheat Flour Allergy",
  "Soy Bean Allergy",
  "Baker's Yeast Allergy",
  "Nut Mix Allergy",
  "Peanut Allergy",
  "Orange Allergy",
  "Strawberry Allergy",
  "Banana Allergy",
  "Mango Allergy",
  "Tomato Allergy",
  "Carrot Allergy",
  "Onion Allergy",
  "Chicken Allergy",
  "Lamb Allergy",
  "Codfish Allergy",
  "Shrimp/Prawn Allergy",
  "HbF",
  "HbA",
  "HbS",
  "HbC",
  "HbD",
  "Unidentified",
  "HbA2",
  "D-Dimer",
  "Lipase",
  "Occult Blood in Stool",
  "Stool Color",
  "Stool Consistency",
  "Stool Odour",
  "Stool Mucus",
  "Visible Blood",
  "Red Blood Cell",
  "Pus Cells in Stool",
  "Polymorphonuclear Leukocytes",
  "Trophozoites",
  "Cysts",
  "OVA",
  "Adult Parasite",
  "Undigested Food",
  "Stool Specimen Type",
  "Organism Isolated",
  "Semen Type",
  "Primary Smear of Semen",
  "Ampicillin",
  "Amoxycillin",
  "Amoxycillin + Clavulanic Acid",
  "Ampicillin + Salbactum",
  "Piperacillin",
  "Ticarcillin",
  "Amikacin",
  "Cotrimoxazole",
  "Tetracycline",
  "Ciprofloxacin",
  "Levofloxacine",
  "Oflaxacine",
  "Imipenem",
  "Meropenem",
  "Piperacillin + Tazobactum",
  "Norfloxacin",
  "Ticarcillin + Clavulanic Acid",
  "Cefazolin",
  "Cefuroxime",
  "Cefoxitin",
  "Cefitriaxone",
  "Cefotaxime",
  "Ceftazidime",
  "Cefoperazone + Sulbactum",
  "Cefepime",
  "Aztreonam",
  "Gentamicin",
  "Appearance of Semen",
  "WBCs",
  "RBCs",
  "Abstinence Period",
  "Collection Time",
  "Analysis Time",
  "Volume of Semen",
  "Liquefaction",
  "pH of Semen",
  "Sperm Count / ml",
  "Sperm Count / ejaculate",
  "Motile",
  "Progressive",
  "Non Progressive",
  "Immotile",
  "Normal Form",
  "Abnormal Form",
  "Abnormal Head",
  "Abnormal Neck 8 midpiece",
  "Abnormal Tail",
  "IgM Level",
  "Varicella Zoster Ab IgG",
  "IgE Total",
  "CK-MB",
  "CK-Total",
  "Troponin I",
  "Covid-19 IgG",
  "COVID 19 IgM",
  "COVID Antibody",
  "COVID RT-PCR",
  "Cycle Threshold N-gene",
  "Cycle Threshold E-gene",
  "Cycle Threshold RDRP",
  "Cycle Threshold Orf 1a-gene",
  "Toxoplasma Ab IgG",
  "Toxoplasma Ab IgM",
  "Rubella Ab IgG",
  "Rubella Ab IgM",
  "Alfa Feto Protein (AFP)",
  "Growth Hormone",
  "Cortisol Serum (p.m)",
  "IL6",
  "Timothy Grass",
  "Cultivated Rye",
  "Alder",
  "Birch",
  "Oak",
  "Olive Tree",
  "Commn Ragweed",
  "Mugwort",
  "Dermatophagoides Pter",
  "Dermatophagoides Farinae",
  "Cockroach, German",
  "Cat",
  "Dog",
  "Horse",
  "Camel",
  "Penicillium Notatum",
  "Caldosporium Herbarium",
  "Aspergillus Fumigatus",
  "Candida Albicans",
  "Alternaria Alternata",
  "Lupus Anticoagulant",
  "Anti Cardiolipin IgM",
  "Anti Cardiolipin IgG",
  "Anti CCP",
  "Anti DNA Abs.",
  "Coombs Test (Indirect)",
  "Anti-Phospholipid (IgG)",
  "Anti-Phospholipid (IgM)",
  "ANA-Titer",
  "Anti Nuclear Antibodies (ANA)",
  "Serum Copper",
  "Aluminium",
  "Antimony",
  "Arsenic",
  "Barium",
  "Beryllium",
  "Bismuth",
  "Cadmium",
  "Caesium",
  "Chromium",
  "Cobalt",
  "Lead",
  "Manganese",
  "Mercury",
  "Molybdenum",
  "Nickel",
  "Selenium",
  "Silver",
  "Strontium",
  "Thallium",
  "Tin",
  "Uranium",
  "Vanadium",
  "Anti-TPO",
  "Anti-Tissue Transglutaminase IgA",
  "TG : HDL Ratio",
  "MYELOBLAST",
  "ABNORMAL CELLS",
  "Lymphoblasts",
  "HEMOPARASITES",
  "LIC%",
  "LIC#",
  "Vitamin B3",
  "Platelet Crit",
  "Mixed Cells",
  "Total Diff %",
  "Alpha 1 Globulin",
  "Alpha 2 Globulin",
  "Beta 1 Globulin",
  "Beta 2 Globulin",
  "Gamma Globulin",
  "A:G Ratio",
  "M Spike",
  "Phosphate",
  "Anti Cardiolipin IgA",
  "Microorganism",
  "Spermatozoa",
  "Trichomonas Vaginalis",
  "XRAY",
];
